$(document).ready(function() {
   $('.filters-toolbar__input, .product-form__controls-group__variant select, #BlogTagFilter').selectric();
  
  $('.page-content img').each(function(i){


    if($(this).parent('div').css('text-align') == 'left'){
      $(this).parent('div').addClass('align-left');
    }

    if($(this).parent('div').css('text-align') == 'right'){
      $(this).parent('div').addClass('align-right');
    }



    if($(this).parent('div').css('text-align') == 'center'){
      $(this).parent('div').addClass('align-center');
    }

  });
  
  
  
  
  
  
  var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}
  
  
  
  /**/
  
  $('.qtyfield a').removeAttr( "target" );
  
  var addInput = '#Quantity-product-template'; //This is the id of the input you are changing
  var n = 1; //n is equal to 1
  
  //Set default value to n (n = 1)
  $(addInput).val(n);

  //On click add 1 to n
  $('.plus').on('click', function(){
    $(addInput).val(++n);
    $('#qtyvalue').text(n);
  })

  $('.min').on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n
    if (n >= 2) {
      $(addInput).val(--n);
      $('#qtyvalue').text(n);
    } else {
      //Otherwise do nothing
    }
  });
  /**/
  
  
  
  
  //IMAGE SLIDER Functinality
  $(".slider-prev").attr("disabled", true);
  $(".slider-prev").click(function(){
    currentIndex = parseInt($("a.active-thumb img").attr("id"));    
    $("img#"+parseInt(currentIndex-1)).trigger("click");
    return false;
  });
  
  $(".slider-next").click(function(){
    currentIndex = parseInt($("a.active-thumb img").attr("id")); 
    $("img#"+parseInt(currentIndex+1)).trigger("click");
    return false;
  });
  
  $(".btnSliderAction").click(function(){
    currentIndex = parseInt($("a.active-thumb img").attr("id"));
    totalLength = parseInt($("a.product-single__thumbnail--product-template").length);
    $(".slider-prev").removeAttr("disabled");
    $(".slider-next").removeAttr("disabled");
    if(currentIndex == 1) {
      $(".slider-prev").attr("disabled", true);
    }    
    if(currentIndex == totalLength){
      $(".slider-next").attr("disabled", true);
    }
    return false;
  });
  
});